/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_POLL_ANSWER } from "./actionTypes"
import { editPollAnswerError, editPollAnswerSuccess } from "./actions"

//Include Both Helper File with needed methods
import { updatePollAnswer } from "../../../helpers/backend_helper"

function* edit(request) {
  try {
    const response = yield call(updatePollAnswer, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(editPollAnswerSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(editPollAnswerError(error.message))
  }
}

function* pollAnswerEditSaga() {
  yield takeEvery(EDIT_POLL_ANSWER, edit)
}

export default pollAnswerEditSaga
